<div class="file-preview">
    <img [src]="getSvgFile()" class="file-preview-overlay">
    <span [ngClass]="getClassIconText()" class="file-preview-overlay"
          data-cy="upload-progress-file-extension">{{extension}}</span>
</div>
